import $store from '../store'

const AppMixin = {
  install(Vue, options) {
    Vue.mixin({
      data() {
        return {
          dataTableFixedHeight: 400
        }
      },
      mounted() {
        this.dataTableFixedHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      },
      methods: {
        checkPermission(claim) {
          if (!claim)
            return true
          var userClaims = $store.getters['auth/getCurrentUserClaims']
          return userClaims && userClaims.findIndex(x => x.value === claim) > -1
        },
        checkActivePart(part) {
          // اگر part دارای نقطه (.) بود، به عنوان مسیر آبجکت تو در تو تعبیر شود
          if (part && part.includes('.')) {
            var parts = part.split('.')
            var activeParts = $store.getters['siteConfig/activeParts']
            let val = activeParts
            for (let i = 0; i < parts.length; i++) {
              if (val && typeof val === 'object' && parts[i] in val) {
                val = val[parts[i]]
              } else {
                return false
              }
            }
            return !!val
          }

          var activeParts = $store.getters['siteConfig/activeParts']
          return !part || (activeParts && activeParts[part])
        }
      }
    })
  }
}

export default AppMixin
